// Import the functions you need from the SDKs you need
import { FirebaseApp, initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"; // Add this import
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDGpUaIV9hUWrCtG8mcgOlBaVY2igqdS9I",
  authDomain: "pocketpediaa.firebaseapp.com",
  projectId: "pocketpediaa",
  storageBucket: "pocketpediaa.firebasestorage.app",
  messagingSenderId: "210230769467",
  appId: "1:210230769467:web:888f9d6352d2ad2e56e91e",
  measurementId: "G-VLQYG92N70"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app); // Initialize Firestore
export const auth = getAuth(app);

export { app, db };

